import Button from '@rio-cloud/rio-uikit/Button';
import Dialog from '@rio-cloud/rio-uikit/Dialog';
import type { ReactNode } from 'react';

interface ExternalDocumentationDialogProps {
    iframeTitle: string;
    onClose: () => void;
    show: boolean;
    title: ReactNode;
    trackingKey: string;
    url: string;
}

export const ExternalDocumentationDialog = (props: ExternalDocumentationDialogProps) => {
    const { iframeTitle, onClose, show, title, trackingKey, url } = props;

    return (
        <Dialog
            show={show}
            title={title}
            body={
                <div className='iframe-wrapper'>
                    <iframe
                        className='unstyled bg-lighter full-window no-application-header'
                        src={url}
                        title={iframeTitle}
                    />
                </div>
            }
            bsSize={Dialog.SIZE_FULL_SCREEN}
            bodyClassName='padding-0'
            headerButtons={
                <Button
                    aria-label='Close'
                    autoTrackingKey={`${trackingKey}.close`}
                    bsStyle={Button.MUTED}
                    iconName='rioglyph-remove'
                    iconOnly
                    onClick={onClose}
                />
            }
            onClose={onClose}
            showCloseButton={false}
        />
    );
};
